export default {
  normal: '普通货物',
  currentResult: '当前识别结果: '
}
